<template>
  <router-view />
</template>

<style lang="scss">
  @import "@/assets/scss/_reset";
  @import "@/assets/scss/_normalise";
  @import "@/assets/scss/_fonts";
  @import "@/assets/scss/_layout";
  @import "@/assets/scss/_buttons";
  @import "@/assets/scss/_ui";
  @import "@/assets/scss/_icons";
  @import "@/assets/scss/_elements";
  @import "@/assets/scss/_form";
  @import "@/assets/scss/_text";
  @import "@/assets/scss/_slider";
  @import "@/assets/scss/_tooltips";
  @import "@/assets/scss/_tables";
  @import "@/assets/scss/_images";
  @import "@/assets/scss/_multiselect";
  // enable to test app CSS compatibility and overrides when placed in choice template
  // @import "@/assets/css/deploy-modules";
</style>
